// actionTypes.js
export const SET_VALUE_FACTURE = "SET_VALUE_FACTURE";
export const SET_STATUT_FACTURE = "SET_STATUT_FACTURE";
export const SET_CURRENT_PAGE_FACTURE = "SET_CURRENT_PAGE_FACTURE";
export const SET_ORDER_FACTURE = "SET_ORDER_FACTURE";
export const SET_SORT_FIELD_FACTURE = "SET_SORT_FIELD_FACTURE";
